import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getOrderInProgress, hasCardPaymentInProgress } from '../../selectors/order'
import { updateOrderInProgress } from '../../actions/order'
import { isCreditType, isTabbed } from '../../utils/orderStates'
import { setReopenedTabPayments } from '../ActionCreators'

export const pluckAuthPayment = (order) => {
  const index = order.payments.findIndex(
    (payment) => isCreditType(payment?.paymentType) && payment.userAttributes?.transType === 'auth',
  )
  const auth = {
    ...order.payments[index],
    userAttributes: {
      ...order.payments[index]?.userAttributes,
      isOriginalAuth: true,
      paymentId: order?.payments[index]?.paymentId,
    },
  }

  return { auth, payments: order.payments.filter((_, i) => i !== index) }
}

export const useAuths = () => {
  const dispatch = useDispatch()
  const order = useSelector(getOrderInProgress)
  const hasCardAuth = useSelector(hasCardPaymentInProgress)

  /**
   * Stash auth payment for later use when reopening tab order with auth
   *
   * @returns {string|undefined} paymentId of stashed auth payment
   */
  const stashAuthPaymentForLaterUse = useCallback(
    (markAsNeedingToVoid = true) => {
      if (!hasCardAuth) return
      if (!isTabbed(order)) return

      const { auth, payments } = pluckAuthPayment(order)

      dispatch(setReopenedTabPayments({ orderUuid: order?.uuid, payments: [auth] }))
      dispatch(
        updateOrderInProgress({
          payments,
          originalTransactionId: order.cardReaderData?.uuid,
          neededToBeVoidedAuthPayment: markAsNeedingToVoid ? [auth] : null,
        }),
      )

      return auth?.paymentId
    },
    [hasCardAuth, order, dispatch],
  )

  return {
    stashAuthPaymentForLaterUse,
  }
}
